<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="bestCandidate"
            v-bind="$attrs"
            :outlined="outlined"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            use-input
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:no-option>
                <div>
                    <q-radio v-model="availability" val="available" label="Dispo." @input="$refs.bestCandidate.filter; $refs.bestCandidate.showPopup()" />
                    <q-radio v-model="availability" val="unavailable" label="Non dispo." @input="$refs.bestCandidate.filter; $refs.bestCandidate.showPopup()" />
                    <q-radio v-model="availability" val="all" label="Tout" @input="$refs.bestCandidate.filter; $refs.bestCandidate.showPopup()" />
                </div>
                <q-item>
                    <q-item-section class="text-italic text-grey">
                        Aucun candidat trouvé
                    </q-item-section>
                </q-item>
            </template>
            <template v-slot:before-options>
                <div>
                    <q-radio v-model="availability" val="available" label="Dispo." @input="$refs.bestCandidate.filter; $refs.bestCandidate.showPopup()" />
                    <q-radio v-model="availability" val="unavailable" label="Non dispo." @input="$refs.bestCandidate.filter; $refs.bestCandidate.showPopup()" />
                    <q-radio v-model="availability" val="all" label="Tout" @input="$refs.bestCandidate.filter; $refs.bestCandidate.showPopup()" />
                </div>
            </template>
            <template v-slot:option="scope">
                <q-item
                    v-bind="scope.itemProps"
                    v-on="scope.itemEvents"
                    style="width:450px"
                >
                    <div class="c-best-candidate" style="width:100%;">
                        <div style="float:right;width:auto">
                            <q-rating
                                :value="scope.opt.rating/20"
                                size="0.8rem"
                                :max="5"
                                color="green"
                                icon-half="circle_half"
                                icon="circle_border"
                                icon-selected="circle"
                                readonly
                            />
                            <div>
                                <small>
                                    <div>Rating : {{ scope.opt.rating }}</div>
                                    <div>Relevancy : {{ scope.opt.relevancy.toFixed(2) }}</div>
                                </small>
                            </div>
                        </div>
                        <div style="width:auto">{{ scope.opt.label }}</div>
                        <div><small>{{ scope.opt.email }} </small></div>
                        <small v-if="scope.opt.profession">
                            <q-chip size="sm" square color="primary" text-color="white">{{ scope.opt.profession }}</q-chip>
                        </small>

                        <small
                            v-bind:key="skill.id+'-'+index"
                            v-for="(skill, index) in scope.opt.skills"
                        >
                            <q-chip
                                size="sm"
                                square
                                :color="variables.tags.includes(skill.id) ? 'warning' : ''"
                                :text-color="variables.tags.includes(skill.id) ? 'white' : ''"
                            >
                                {{ skill.name }}
                            </q-chip>
                        </small>
                        <small
                            v-bind:key="course.id+'-'+index"
                            v-for="(course, index) in scope.opt.courses"
                        >
                            <q-chip
                                size="sm"
                                square
                                :color="variables.tags.includes(course.id) ? 'positive' : ''"
                                :text-color="variables.tags.includes(course.id) ? 'white' : ''"
                            >
                                {{ course.name }}
                            </q-chip>
                        </small>

                    </div>
                </q-item>
            </template>

        </q-select>
    </div>
</template>

<script>
    import { BESTCANDIDATE } from '@/graphql/user/queries'
    import QSelect from 'quasar'

    export default {
        name: 'BestCandidateInput',
        extends: QSelect,
        data(){
            return{
                searchText: null,
                bestCandidates: [],
                availability: 'available'
            }
        },
        props: {
            variables: {
                type: Object,
                default() {
                    return {
                        professions: Number,
                        tags: Array
                    }
                }
            },
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        mounted(){
        },
        computed: {
            menuItems() {
                return this.bestCandidates;
            },
            queryVariables(){
                return {...this.variables, search: this.searchText, availability: this.availability } 
            }
        },
        methods: {
            search(searchText, updatefn){
                this.searchText=searchText;

                this.$apollo.query({
                    query: BESTCANDIDATE,
                    fetchPolicy: 'network-only',
                    variables: {...this.queryVariables},
                }).then((data) => {
                    this.bestCandidates=Object.assign([], data.data.bestCandidates);
                    updatefn();
                })
            }
        }
    }

</script>

<style lang="scss" scoped>
    .bestCandidates {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }

    @import "@/scss/components/globals/BestCandidate.scss";
</style>
